import React from 'react';
import Select from '../../../components/ui/Select';

const CitizenshipFilter = ({ value, onChange }) => {
  const citizenshipOptions = [
    { value: 'all', label: 'All Citizenship Status' },
    { value: 'citizen', label: 'PNG Citizens' },
    { value: 'non-citizen', label: 'Non-Citizens' },
    { value: 'permanent-resident', label: 'Permanent Residents' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full min-w-0">
      <Select
        label="Citizenship Status"
        options={citizenshipOptions}
        value={value}
        onChange={onChange}
        placeholder="Select citizenship status"
        className="w-full"
      />
    </div>
  );
};

export default CitizenshipFilter;